import { Button } from '../../../../components/ui/Button';
import { FieldHelp } from '../../../../components/ui/FieldHelp';
import { Textarea } from '../../../../components/ui/Textarea';
import type { usePosterCopy } from './usePosterCopy';
import styles from './Page.module.css';

export function PosterCopyField({ copy, label, help }: { copy: ReturnType<typeof usePosterCopy>; label: string; help: string }) {
  const feedbackId = `poster-copy-${copy.field}-feedback`;
  const inputId = `poster-copy-${copy.field}-input`;
  return <div className={styles.copyField}>
    <div className={styles.copyHeading}>
      <div className={styles.fieldLabel}>{label}<FieldHelp content={help} label={`${label}说明`} /></div>
      <div aria-atomic="true" aria-live="polite" className={styles.copyFeedback} data-failed={copy.status === 'failed' || undefined} id={feedbackId}>
        {copy.status === 'saving' ? '保存中…' : copy.status === 'saved' ? '已保存' : copy.status === 'failed' ? <><span>保存失败</span><Button aria-label={`重试保存${label}`} className={styles.copyRetry} onClick={() => { document.getElementById(inputId)?.focus(); void copy.save(); }} size="small" type="default">重试</Button></> : null}
      </div>
    </div>
    <Textarea aria-describedby={feedbackId} ariaLabel={label} className={styles.copyInput} id={inputId} maxLength={20} onBlur={() => { void copy.save(); }} onCompositionEnd={event => copy.compositionEnd(event.currentTarget.value)} onCompositionStart={copy.compositionStart} onValueChange={copy.change} showCount value={copy.value} />
  </div>;
}
